"use client";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { ReactNode, createContext, useContext } from "react";
import { ContextProps, Info } from "@/types/user";
import getUser from "@/app/actions/get-user";

const UserContext = createContext({} as ContextProps);

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const {
    data: userInfo,
    error: userError,
    isLoading: userPending,
    isError: isUserError,
  } = useQuery({
    queryKey: ["user"],
    queryFn: getUser,
  }) as UseQueryResult<Info>;

  return (
    <UserContext.Provider
      value={{
        userInfo,
        userPending,
        isUserError,
        userError
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
